<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Avance de Justificaciones — Trámite N.° {{ p_idtramite }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

<div class="card border-0 mb-3" style="background-color: #e8f4fd;">
  <div class="card-body py-2 px-3">
    <span class="text-dark fw-bold">{{ datosTramite }}</span>
  </div>
</div>
    <!-- Filtros -->
    <div class="row g-2 align-items-end mb-3">
      <div class="col-auto">
        <label class="form-label mb-0 small fw-bold">Tipo de observación</label>
        <select v-model="tipoSeleccionado" class="form-select form-select-sm" @change="cargarDatos">
          <option value="">Seleccione...</option>
          <option value="M">Auditoría Médica</option>
          <option value="D">Gestión Documental</option>
        </select>
      </div>
      <div class="col-auto">
        <button
          @click="cargarDatos"
          class="btn btn-primary btn-sm d-flex align-items-center gap-1"
          :disabled="!tipoSeleccionado || cargando"
        >
          <span class="material-icons" style="font-size: 16px">refresh</span>
          Actualizar
        </button>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <!-- Sin selección -->
    <div v-else-if="!tipoSeleccionado" class="alert alert-secondary py-2 px-3" role="alert">
      Seleccione un tipo de observación para cargar los datos.
    </div>

    <div v-else>

      <!-- Tarjetas resumen -->
      <div class="row g-3 mb-4">
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
            <div class="small text-muted fw-bold">Respondidas</div>
            <div class="fs-4 fw-bold text-dark">{{ resumen.respondidas }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
            <div class="small text-muted fw-bold">Justificadas</div>
            <div class="fs-4 fw-bold text-success">{{ resumen.justificadas }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
            <div class="small text-muted fw-bold">Sin justificar</div>
            <div class="fs-4 fw-bold text-danger">{{ resumen.sinJustificar }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
            <div class="small text-muted fw-bold">Avance global</div>
            <div class="fs-4 fw-bold" :class="colorPorcentaje(resumen.porcentaje)">
              {{ resumen.porcentaje }}%
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'grafico' }"
            href="#"
            @click.prevent="activeTab = 'grafico'"
          >
            <span class="material-icons align-middle me-1" style="font-size: 16px">bar_chart</span>
            Gráfico de avance
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'tabla' }"
            href="#"
            @click.prevent="activeTab = 'tabla'"
          >
            <span class="material-icons align-middle me-1" style="font-size: 16px">table_chart</span>
            Tabla de avance
          </a>
        </li>
      </ul>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Gráfico                                       -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'grafico'">
        <div v-if="porCarga.length === 0" class="alert alert-warning">
          No hay registros respondidos para mostrar.
        </div>
        <div v-else>
          <div
            v-for="item in porCarga"
            :key="item.idCarga"
            class="mb-3"
          >
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="small fw-bold">{{ labelCarga(item.idCarga) }}</span>
              <span class="small text-muted">
                {{ item.justificadas }} justificadas / {{ item.respondidas }} respondidas
                — {{ item.porcentaje }}%
              </span>
            </div>
            <div
              class="progress"
              style="height: 22px; border-radius: 4px; background-color: #dee2e6;"
            >
              <div
                class="progress-bar"
                :style="{
                  width: item.porcentaje + '%',
                  backgroundColor: colorBarra(item.porcentaje),
                  transition: 'width 0.6s ease',
                }"
                :title="`Justificadas: ${item.justificadas} (${item.porcentaje}%)`"
              >
                <span v-if="item.porcentaje > 10" class="small fw-bold">
                  {{ item.porcentaje }}%
                </span>
              </div>
            </div>
            <div class="d-flex gap-3 mt-1">
              <span class="small">
                <span
                  class="badge"
                  :style="{ backgroundColor: colorBarra(item.porcentaje) }"
                >{{ item.justificadas }}</span>
                justificadas
              </span>
              <span class="small">
                <span class="badge bg-danger">{{ item.sinJustificar }}</span>
                sin justificar
              </span>
              <span class="small text-muted">
                (de {{ item.respondidas }} respondidas)
              </span>
            </div>
          </div>

          <!-- Leyenda -->
          <div class="d-flex gap-3 mt-4 pt-3 border-top">
            <div class="d-flex align-items-center gap-1">
              <div style="width: 14px; height: 14px; background: #198754; border-radius: 2px;"></div>
              <span class="small text-muted">≥ 75% justificado</span>
            </div>
            <div class="d-flex align-items-center gap-1">
              <div style="width: 14px; height: 14px; background: #fd7e14; border-radius: 2px;"></div>
              <span class="small text-muted">50–74%</span>
            </div>
            <div class="d-flex align-items-center gap-1">
              <div style="width: 14px; height: 14px; background: #dc3545; border-radius: 2px;"></div>
              <span class="small text-muted">&lt; 50%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════════ -->
      <!-- Tab: Tabla                                         -->
      <!-- ══════════════════════════════════════════════════ -->
      <div v-if="activeTab === 'tabla'">
        <div v-if="porCarga.length === 0" class="alert alert-warning">
          No hay registros respondidos para mostrar.
        </div>
        <div class="table-responsive" v-else>
          <table class="table table-hover table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th class="th-sort" @click="ordenarTabla('idCarga')">
                  Período <span>{{ iconOrdenTabla('idCarga') }}</span>
                </th>
                <th class="th-sort" @click="ordenarTabla('respondidas')">
                  Respondidas <span>{{ iconOrdenTabla('respondidas') }}</span>
                </th>
                <th class="th-sort" @click="ordenarTabla('justificadas')">
                  Justificadas <span>{{ iconOrdenTabla('justificadas') }}</span>
                </th>
                <th class="th-sort" @click="ordenarTabla('sinJustificar')">
                  Sin justificar <span>{{ iconOrdenTabla('sinJustificar') }}</span>
                </th>
                <th class="th-sort" @click="ordenarTabla('porcentaje')">
                  % Avance <span>{{ iconOrdenTabla('porcentaje') }}</span>
                </th>
                <th>Progreso</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in porCargaOrdenada" :key="item.idCarga">
                <td class="fw-bold">{{ labelCarga(item.idCarga) }}</td>
                <td>{{ item.respondidas }}</td>
                <td>
                  <span class="badge bg-success">{{ item.justificadas }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="item.sinJustificar > 0 ? 'bg-danger' : 'bg-secondary'"
                  >{{ item.sinJustificar }}</span>
                </td>
                <td>
                  <span class="fw-bold" :class="colorPorcentaje(item.porcentaje)">
                    {{ item.porcentaje }}%
                  </span>
                </td>
                <td style="min-width: 120px;">
                  <div class="progress" style="height: 14px; border-radius: 3px;">
                    <div
                      class="progress-bar"
                      :style="{
                        width: item.porcentaje + '%',
                        backgroundColor: colorBarra(item.porcentaje),
                      }"
                    ></div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary fw-bold">
                <td>Total</td>
                <td>{{ resumen.respondidas }}</td>
                <td>
                  <span class="badge bg-success">{{ resumen.justificadas }}</span>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="resumen.sinJustificar > 0 ? 'bg-danger' : 'bg-secondary'"
                  >{{ resumen.sinJustificar }}</span>
                </td>
                <td :class="colorPorcentaje(resumen.porcentaje)">
                  {{ resumen.porcentaje }}%
                </td>
                <td>
                  <div class="progress" style="height: 14px; border-radius: 3px;">
                    <div
                      class="progress-bar"
                      :style="{
                        width: resumen.porcentaje + '%',
                        backgroundColor: colorBarra(resumen.porcentaje),
                      }"
                    ></div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

export default {
  name: "AvanceJustificaciones",
  components: { Layout, Footer },

  props: {
    p_idtramite: { type: Number, required: true },
  },

  data() {
    return {
      tipoSeleccionado:  "",
      cargando:          false,
      activeTab:         "grafico",
      datos:             [],
      cargas:  [],
      campoOrdenTabla:   "idCarga",
      ascendenteTabla:   true,
      datosTramite: "",
    };
  },

  computed: {
    // ── Solo los respondidos (tienen idRespuesta) ─────────
    soloRespondidos() {
      return this.datos.filter(d => d.idRespuesta);
    },

    // ── Agrupar por idCarga ───────────────────────────────
    porCarga() {
      const mapa = {};
      this.soloRespondidos.forEach(item => {
        const clave = item.idCarga;
        if (!mapa[clave]) {
          mapa[clave] = { idCarga: clave, respondidas: 0, justificadas: 0 };
        }
        mapa[clave].respondidas++;
        if (item.revisado === 1) {
          mapa[clave].justificadas++;
        }
      });
      return Object.values(mapa).map(g => ({
        ...g,
        sinJustificar: g.respondidas - g.justificadas,
        porcentaje: g.respondidas > 0
          ? Math.round((g.justificadas / g.respondidas) * 100)
          : 0,
      })).sort((a, b) => a.idCarga - b.idCarga);
    },

    // ── Tabla ordenada ────────────────────────────────────
    porCargaOrdenada() {
      const campo = this.campoOrdenTabla;
      return [...this.porCarga].sort((a, b) => {
        const va = a[campo] ?? 0;
        const vb = b[campo] ?? 0;
        return this.ascendenteTabla ? va - vb : vb - va;
      });
    },

    // ── Resumen global ────────────────────────────────────
    resumen() {
      const respondidas  = this.soloRespondidos.length;
      const justificadas = this.soloRespondidos.filter(d => d.revisado === 1).length;
      const sinJustificar = respondidas - justificadas;
      const porcentaje   = respondidas > 0
        ? Math.round((justificadas / respondidas) * 100)
        : 0;
      return { respondidas, justificadas, sinJustificar, porcentaje };
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchCargas();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    async cargarDatos() {
      if (!this.tipoSeleccionado) return;
      this.cargando = true;
      try {
        const { data } = await api.get("/vwobservaciones/tramite-buscar-todos", {
          params: {
            idTramite: this.p_idtramite,
            tipo:      this.tipoSeleccionado,
          },
        });
        this.datos = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error("Error al cargar datos:", e);
        this.datos = [];
      } finally {
        this.cargando = false;
      }
    },

    ordenarTabla(campo) {
      if (this.campoOrdenTabla === campo) {
        this.ascendenteTabla = !this.ascendenteTabla;
      } else {
        this.campoOrdenTabla = campo;
        this.ascendenteTabla = true;
      }
    },
    iconOrdenTabla(campo) {
      if (this.campoOrdenTabla !== campo) return "⇅";
      return this.ascendenteTabla ? "↑" : "↓";
    },

    colorBarra(pct) {
      if (pct >= 75) return "#198754";
      if (pct >= 50) return "#fd7e14";
      return "#dc3545";
    },
    colorPorcentaje(pct) {
      if (pct >= 75) return "text-success";
      if (pct >= 50) return "text-warning";
      return "text-danger";
    },
async fetchCargas() {
  try {
    const { data } = await api.get(`/vwcargas/activas-por-tramite/${this.p_idtramite}`);
    this.cargas = Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("Error al cargar cargas:", e);
  }
},

labelCarga(idCarga) {
  const carga = this.cargas.find(c => c.idCarga === idCarga);
  return carga ? `Período ${carga.secuencial}` : `Carga ${idCarga}`;
},
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
</style>	